import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "../../components/Button";
import { authState, useAuth } from "../../states/authState";
import { RiotAccountMenu } from "@shared/Toolbar/AuthButton/RiotAccountMenu";

interface UserMenuProps {
	onClose: () => void;
}

const UserMenu: React.FC<UserMenuProps> = (props) => {
	const { user } = useAuth();
	const navigate = useNavigate();

	const handleLogout = () => {
		authState.accessToken = undefined;
		authState.user = undefined;
		navigate("/");
		props.onClose();
	};

	if (!user) return null;

	return (
		<div
			className={
				"p-2 bg-base-200  border-black/20 drop-shadow-md shadow-outline border-2 shadow-black rounded"
			}
		>
			<div className={"text-white mb-2"}>
				<div className={"font-bold"}>Logged in as:</div>
				<div>{user.email}</div>
			</div>

			<RiotAccountMenu />

			<div className={"flex gap-4 mt-4 border-t border-black pt-4"}>
				<Button onClick={handleLogout} variant={"default"}>
					Log out
				</Button>
			</div>
		</div>
	);
};

export { UserMenu };
